import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/core.scss';
import css from './index.scss';

const MultilineText = ({ dataItems = [], dataItemClassName = '' }) => {
    let multilineText = [];
    let index = 1;
    if (dataItems.length > 0) {
        if (dataItemClassName === '') {
            multilineText = dataItems.map((dataItem) => {
                index += 1;
                return <div key={`${dataItem}_${index}`}>{dataItem}</div>;
            });
        } else {
            multilineText = dataItems.map((dataItem) => {
                index += 1;
                return <div className={dataItemClassName} key={`${dataItem}_${index}`}>{dataItem}</div>;
            });
        }
    }

    return (
        <div className={css.component}>
            {multilineText}
        </div>
    );
};

MultilineText.propTypes = {
    dataItems: PropTypes.array,
    dataItemClassName: PropTypes.string
};

export default MultilineText;



// WEBPACK FOOTER //
// ./app/components/multiline-text/index.js